import React from 'react';
import PropTypes from 'prop-types';
import MobileFittingServices from './details/mobile_fitting_services';
import OpeningHours from './details/opening_hours';
import IncludedServices from './details/services';
import Services from './details/additional_services';
import { Costs } from './details/costs';
import Image from './details/image';
import FitterReviews from './details/reviews/fitter_reviews_container';

function Details(props) {
    const wheelAlignment2 = props.wheelAlignment2;
    const wheelAlignmentwheels_2 = props.wheelAlignmentwheels_2;
    const wheelAlignment4 = props.wheelAlignment4;
    const wheelAlignmentwheels_4 = props.wheelAlignmentwheels_4;

    return (
        <div className="fsf-station__details fsf-station__section">
            <div className="fsf-station__details-wrapper">
                <MobileFittingServices isMobileFitter={props.isMobileFitter} mobileFittingPostCodes={props.mobileFittingPostCodes} />

                {props.productsQty !== 0 &&
                    <Costs
                        wheelAlignment={wheelAlignment2 ? wheelAlignmentwheels_2 : wheelAlignment4 ? wheelAlignmentwheels_4 : ''}
                        wheelAlignment2IsShowable={props.wheelAlignment.wheels_2_is_showable}
                        wheelAlignment4IsShowable={props.wheelAlignment.wheels_4_is_showable}
                        wheelAlignmentWheelCount={props.wheelAlignmentWheelCount}
                        fittingCosts={props.fittingCosts}
                        totalShipping={props.totalShipping}
                        calloutFee={props.calloutFee}
                        totalCart={props.totalCart}
                        onWheels2Change={props.onWheels2Change}
                        onWheels4Change={props.onWheels4Change}
                        productBrand={props.productBrand}
                        productModel={props.productModel}
                        productManufacturer={props.productManufacturer}
                        productDimensions={props.productDimensions}
                        productsPrice={props.productsPrice}
                        isMarketplaceSeller={props.isMarketplaceSeller}
                        productStock={props.productStock}
                        productsQty={props.productsQty}
                        discount={props.discount}
                        discountInfo={props.discountInfo}
                        allDiscounts={props.allDiscounts}
                        buy4Pay3={props.buy4Pay3}
                        shippingWarning={props.shippingWarning}
                        
                    />
                }
                <Services
                    wheelAlignment={props.wheelAlignment}
                    wheelAlignment2={props.wheelAlignment2}
                    wheelAlignment4={props.wheelAlignment4}
                    onWheels2Change={props.onWheels2Change}
                    onWheels4Change={props.onWheels4Change}
                    displayAdditionalServices={props.displayAdditionalServices}
                    showSelectStationButton={props.showSelectStationButton}
					onShowMoreWheelAlignmentInfoClick={props.onShowMoreWheelAlignmentInfoClick}
                />
                <IncludedServices
                    vehicleCollectAndReturnService={props.vehicleCollectAndReturnService}
                    vehicleCollectAndReturnServiceComment={props.vehicleCollectAndReturnServiceComment}
                />
                <OpeningHours openingHours={props.openingHours} />
                <Image image={props.image} address={props.address} />
                {props.reviews.reviews.length > 0 && <FitterReviews reviews={props.reviews.reviews} fsName={props.fsName} />}
            </div>
        </div>
    );
}

Details.propTypes = {
    showSelectStationButton: PropTypes.bool.isRequired,
    wheelAlignment2: PropTypes.bool.isRequired,
    wheelAlignment4: PropTypes.bool.isRequired,
    onWheels2Change: PropTypes.func.isRequired,
    onWheels4Change: PropTypes.func.isRequired,
    onShowMoreWheelAlignmentInfoClick: PropTypes.func.isRequired,
    isMarketplaceSeller: PropTypes.bool,
    productStock: PropTypes.object,
    mpsDoesSameDayFitting: PropTypes.bool,
    mpsDoesSameDayFittingCutoff: PropTypes.string,
    vehicleCollectAndReturnService: PropTypes.bool,
    vehicleCollectAndReturnServiceComment: PropTypes.string,
    buy4Pay3: PropTypes.bool,
    shippingWarning: PropTypes.string,
    fsName: PropTypes.string,

};

Details.defaultProps = {
    vehicleCollectAndReturnService: false,
    vehicleCollectAndReturnServiceComment: '',
    isMarketplaceSeller: false,
    mpsDoesSameDayFitting: false,
    productStock: null,
    buy4Pay3: false,
    fsName: '',
};

export default Details;
